
import React, { memo, useEffect, useRef, useState } from 'react'
//components
import GeneralForm from 'components/common/Forms/GeneralForm/GeneralForm';
import AddModal from 'components/Table/AddModal/AddModal'
import { ProgressSpinner } from 'primereact/progressspinner';


interface AddEquipmentPropType {
    showModal: boolean;
    datafields?: any;
    onHideModal?: () => void;
    onFormSubmit?: (body, reset, setValue?, fieldImages?) => void;
    uniqueEquipmentClassId?: any;
    showProgressBar?: boolean;
}
const AddEquipment: React.FC<AddEquipmentPropType> = (props) => {
    const { showModal, datafields, onHideModal = () => { }, onFormSubmit = () => { }, uniqueEquipmentClassId, showProgressBar } = props;
    const addform = useRef<any>(null);
    const [fieldFocus, setFieldFocus] = useState<boolean>(false);
    const isSubmitPendingRef = useRef(false);

    let body = {
        uniqueEquipmentClassId: uniqueEquipmentClassId
    }

    useEffect(() => {
        if (!showProgressBar) {
            isSubmitPendingRef.current = false;
        }
    }, [showProgressBar]);

    // Validation rejected the submit, so nothing was sent and no progress bar will appear to clear
    // the guard below. Release it here or the modal accepts no further Save clicks.
    const onSubmitInvalid = () => {
        isSubmitPendingRef.current = false;
    }

    const formSubmitHandler = () => {
        if (isSubmitPendingRef.current) return;
        isSubmitPendingRef.current = true;

        // Image uploads to the temp directory happen async; submitting mid-upload would save
        // the text fields but silently drop the image because its tempStorageDirectory isn't
        // known yet. Wait for FilePond to finish before handing off to requestSubmit.
        if (addform?.current?.isUploadingImages?.()) {
            const waitForUpload = setInterval(() => {
                if (!addform?.current?.isUploadingImages?.()) {
                    clearInterval(waitForUpload);
                    addform?.current?.requestSubmit();
                }
            }, 200);
            return;
        }
        addform?.current?.requestSubmit();
    }


    return (
        <AddModal
            header={"New Equipment"}
            showModal={showModal}
            setShowModal={onHideModal}
            OnSaveClick={formSubmitHandler}
            isAdd={true}
            style={{ width: "40vw", maxHeight: "95%" }}
        >
            {showProgressBar &&
                <div className='addEdit-overlay-spinner'>
                    <ProgressSpinner />
                </div>
             }
            <GeneralForm ref={addform} datafields={datafields} isEditForm={false} ddAppendTo='self' onFormSubmit={onFormSubmit} onSubmitInvalid={onSubmitInvalid} body={body} fieldFocus={fieldFocus} setFieldFocus={setFieldFocus}/>
        </AddModal>
    )
}

export default memo(AddEquipment)